import { useCallback } from 'react';
import { Alert, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import { useAppContext } from '@/context';
import { TwoFactorStatusPanel } from './AccountSecurityPanels';
import { useProfileResource } from './profileRequests';

export default function TwoFactorSection() {
  const { apiClients } = useAppContext();
  const load = useCallback(() => apiClients.users.usersProfileMfaStatusRetrieve(), [apiClients.users]);
  const { data, loading, error, retry } = useProfileResource(
    load,
    'Could not load two-factor authentication status. Please retry.',
  );
  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Typography variant="h6" component="h2">
            Two-Factor Authentication
          </Typography>
          {loading && <CircularProgress aria-label="Loading two-factor authentication status" />}
          {error && (
            <Alert
              severity="error"
              action={
                <Button color="inherit" onClick={retry}>
                  Retry
                </Button>
              }
            >
              {error}
            </Alert>
          )}
          {data && <TwoFactorStatusPanel status={data} />}
        </Stack>
      </CardContent>
    </Card>
  );
}
